import { render } from "./ServiceRouteSwitches.vue?vue&type=template&id=5c5347c3&scoped=true"
import script from "./ServiceRouteSwitches.vue?vue&type=script&lang=js"
export * from "./ServiceRouteSwitches.vue?vue&type=script&lang=js"

import "./ServiceRouteSwitches.vue?vue&type=style&index=0&id=5c5347c3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5347c3"]])

export default __exports__